import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import AppComponent from './app.component';

import SharedModule from './shared/shared.module';
import PagesModule from './pages/pages.module';
import ApiModule from './api/api.module';

import 'angular-translate';
import 'angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.js';
import 'angular-translate-storage-local';
import 'angular-translate-storage-cookie';

import { en } from '@shared/locales/locale-en';
import { de } from '@shared/locales/locale-de';
import { fr } from '@shared/locales/locale-fr';
import { es } from '@shared/locales/locale-es';
import environment from 'environment';

angular.module('app', [
  uiRouter,

  SharedModule,
  PagesModule,
  ApiModule,
  'pascalprecht.translate'
])
.config(($urlRouterProvider, $locationProvider, $translateProvider, $windowProvider) => {
  'ngInject';
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode

  $urlRouterProvider.rule(function($injector, $location){
    if($location.path().match(/^\/(settings|transactions|profile|support|activation|dashboard|forgot-password|reset)/i)) {
      return 'redirect-to-mobile' + $location.path();
    }else if ($location.path() === '' || $location.path() === '/') {
      return 'redirect-to-mobile/';
    }
  });

  $urlRouterProvider.otherwise(function($injector, $location) {
    let path = $location.path();
    let matches = path.match(/^\/(redirect-to-mobile)(.*)/i);
    if(matches) {
      $windowProvider.$get().location = environment.MOBILE_SITE_REDIRECT_URL + matches[2];
    }else{
      $location.replace('sign-in');
    }
  });
  $locationProvider.html5Mode(true).hashPrefix('!');

  $translateProvider
    .translations('en', en())
    .translations('de', de())
    .translations('fr', fr())
    .translations('es', es())
    .useSanitizeValueStrategy('sanitizeParameters')
    .preferredLanguage('en')
    .fallbackLanguage('en')
    .useLocalStorage();
})
.component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js